"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NOTIFY_ROUTE_LEAVE_COMPLETE = exports.NOTIFY_PREV_ROUTE_LEAVE = exports.NOTIFY_ROUTE_LEAVE = exports.NOTIFY_ROUTE_RE_ENTER = exports.NOTIFY_EXECUTE_QUEUE_ERROR = exports.NOTIFY_EXECUTE_QUEUE_FINISH = exports.NOTIFY_VISIBILITY_CHANGE = exports.NOTIFY_BEFORE_UNLOAD = exports.NOTIFY_ENTRY_INTERSECT_CALLBACK_END = exports.NOTIFY_EXPOSE_ITEMS = exports.NOTIFY_EXPOSE_CLICK = exports.NOTIFY_ENTRY_INTERSECTED = exports.NOTIFY_ENTRY_INTERSECTING = exports.NOTIFY_INPUT_PASTE = exports.NOTIFY_INPUT = exports.NOTIFY_CLICK = void 0;
exports.NOTIFY_CLICK = "click";
exports.NOTIFY_INPUT = "input";
exports.NOTIFY_INPUT_PASTE = "inputPaste";
exports.NOTIFY_ENTRY_INTERSECTING = "intersecting";
exports.NOTIFY_ENTRY_INTERSECTED = "intersected";
exports.NOTIFY_EXPOSE_CLICK = "coreExposeClick";
exports.NOTIFY_EXPOSE_ITEMS = "exposeItems";
/**
 * intersectionCallBack 回调通知
 */
exports.NOTIFY_ENTRY_INTERSECT_CALLBACK_END = "intersectCallbackEnd";
exports.NOTIFY_BEFORE_UNLOAD = "beforeunload";
exports.NOTIFY_VISIBILITY_CHANGE = "visibilitychange";
exports.NOTIFY_EXECUTE_QUEUE_FINISH = "executeQueueFinish";
exports.NOTIFY_EXECUTE_QUEUE_ERROR = "executeQueueError";
exports.NOTIFY_ROUTE_RE_ENTER = "routeReEnter";
exports.NOTIFY_ROUTE_LEAVE = "routeLeave";
exports.NOTIFY_PREV_ROUTE_LEAVE = "prevRouteLeave";
exports.NOTIFY_ROUTE_LEAVE_COMPLETE = "routeLeaveComplete";
